/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './cip-business-sign-up';

const CipBusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({
    wrapper,
    label,
    errorMessage,
    input,
    isAddressInput,
    isValidateVatButton,
    isSectionHeader
}) => {
    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isValidateVatButton && !isSectionHeader && label}
            {input}
            {!isAddressInput && errorMessage}
        </Node>
    );
};

const CipBusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                {errorMessage &&
                    errorMessage.map((error: React.ReactNode, index: number) => {
                        return <React.Fragment key={index}>{error}</React.Fragment>;
                    })}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <CipBusinessSignUpItem key={item.id} {...item} />;
                        })}
                    {disclaimer}
                    <div className='col-12 cip-business-sign-up__buttons'>
                        {buttons &&
                            buttons.map((button: React.ReactNode, index: number) => {
                                return (
                                    <div className='' key={index}>
                                        {button}
                                    </div>
                                );
                            })}
                    </div>
                </Node>
            </Node>
        </Module>
    );
};

export default CipBusinesSignUpView;
